import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory";
import LoginHeader from "../../components/header/Loginheader";
import Footer from "../../components/footer/FooterW";
import bankicon from "../../images/shapes/bank-pound-icon2 4.png";
import wallet from "../../images/shapes/Group 37274 (1).png";
import success from "../../images/shapes/image 1.png";
import "./Wallet.css";
import { useLocation } from "react-router-dom";
import RewardPopup from "../../components/Rewardpopup/RewardPopup";
import { API_URL } from "../../constant";
import tcunitswallet from "../../images/shapes/tc-units-wallet 2.png";
import tccashwallet from "../../images/shapes/tc-cash-wallet 1.png";
import tcminiwallet from "../../images/shapes/tcuk_agent_wallet 3.png";
import walletcashicon from "../../images/shapes/wallet-cash-icon3 2.png";
import { MdOutlineDone } from "react-icons/md";
import MiniAgentForm from "../../components/MiniAgent/MiniAgentForm";
import Profile from "../../images/shapes/profile-icon-color 3.png";

const Wallet = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [apiStatus, setApiStatus] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300);
  const [step, setStep] = useState("idle");
  const [showFormModal, setShowFormModal] = useState(false);
  const [miniAgentData, setMiniAgentData] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasExistingApplication, setHasExistingApplication] = useState(false);
  const [isMiniAgent, setIsMiniAgent] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [miniAgentWalletBalance, setMiniAgentWalletBalance] = useState(0);
  const [showReturnPopup, setShowReturnPopup] = useState(false);
  const [username, setUsername] = useState("");

  // Session timeout duration
  const SESSION_TIMEOUT = 5 * 60 * 1000;
  const WARNING_TIME = 60 * 1000;

  // Add debug useEffect
  useEffect(() => {
    console.log("🔍 Debug - showReturnPopup state:", showReturnPopup);
    console.log("🔍 Debug - username:", username);
    console.log(
      "🔍 Debug - auth token exists:",
      !!localStorage.getItem("auth_token")
    );
    console.log(
      "🔍 Debug - is_first_login:",
      localStorage.getItem("is_first_login")
    );
    console.log("🔍 Debug - user data:", localStorage.getItem("user"));
    console.log(
      "🔍 Debug - just_logged_in:",
      sessionStorage.getItem("just_logged_in")
    );
  }, [showReturnPopup, username]);

  // Check if user is already a mini agent or has pending application
  const checkMiniAgentStatus = async () => {
    try {
      const token =
        localStorage.getItem("auth_token") ||
        sessionStorage.getItem("auth_token");
      if (!token) return;

      const response = await fetch(
        `${API_URL}/api/advertising-agents/application`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.application) {
          setHasExistingApplication(true);
          setApplicationStatus(data.application.status);

          if (data.application.status === "approved") {
            setIsMiniAgent(true);
            setStep("accepted");
          } else if (data.application.status === "pending") {
            setStep("progress");
          } else if (data.application.status === "rejected") {
            setStep("rejected");
          }
        } else {
          // No existing application
          setStep("idle");
        }
      }
    } catch (error) {
      console.error("Error checking mini agent status:", error);
      setStep("idle");
    }
  };

  const handleRequest = () => {
    // Show form immediately without loading state
    setShowFormModal(true);
  };

  const handleMiniAgentSubmit = async (responseData) => {
    console.log("✅ Mini-Agent Form submitted successfully:", responseData);

    // Save form data
    setMiniAgentData(responseData);

    // Close form modal and show success modal
    setShowFormModal(false);
    setShowSuccessModal(true);

    // Update application status
    setHasExistingApplication(true);
    setApplicationStatus("pending");
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    setStep("progress");

    // Refresh the application status after a short delay
    setTimeout(() => {
      checkMiniAgentStatus();
    }, 1000);
  };

  const handleClick = () => {
    if (balance < 20000) {
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } else {
      alert("Conversion process started!");
    }
  };

  const logout = () => {
    console.log("🔄 Auto-logout due to inactivity");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("is_first_login");
    localStorage.removeItem("last_activity_time");
    localStorage.removeItem("user");
    sessionStorage.removeItem("just_logged_in"); // Clear login flag on logout
    navigate("/sign_in");
  };

  const resetTimer = () => {
    const newTime = Date.now().toString();
    localStorage.setItem("last_activity_time", newTime);
    setTimeLeft(300);
  };

  const setupActivityListeners = () => {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "touchmove",
      "wheel",
    ];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        resetTimer();
      }
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      document.removeEventListener("visibilitychange", resetTimer);
    };
  };

  const checkSession = () => {
    const token = localStorage.getItem("auth_token");
    const lastActivity = localStorage.getItem("last_activity_time");

    if (!token) {
      navigate("/sign_in");
      return false;
    }

    if (lastActivity) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - parseInt(lastActivity);
      const remainingTime = Math.max(0, SESSION_TIMEOUT - elapsedTime);

      setTimeLeft(Math.floor(remainingTime / 1000));

      if (elapsedTime > SESSION_TIMEOUT) {
        logout();
        return false;
      }
    } else {
      resetTimer();
    }

    return true;
  };

  const checkApiStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/laravel-test`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      });

      if (response.ok) {
        setApiStatus(true);
        return true;
      } else {
        setApiStatus(false);
        return false;
      }
    } catch (error) {
      console.error("🚨 API status check failed:", error);
      setApiStatus(false);
      return false;
    }
  };

  const handleTransactionNavigation = (e) => {
    e.preventDefault();
    resetTimer();
    navigate("/customer/transaction");
  };

  const handleMiniTransactionNavigation = (e) => {
    e.preventDefault();
    resetTimer();
    navigate("/mini-agent-transaction-history");
  };

  const processOAuthToken = () => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    const firstLogin = queryParams.get("firstLogin") === "true";

    if (tokenFromUrl) {
      localStorage.setItem("auth_token", tokenFromUrl);
      // Set flag for OAuth login
      sessionStorage.setItem("just_logged_in", "true");
    }

    if (firstLogin) {
      localStorage.setItem("is_first_login", "true");
    }

    resetTimer();

    if (tokenFromUrl || firstLogin) {
      window.history.replaceState({}, document.title, "/customer/wallet");
    }

    return !!(tokenFromUrl || firstLogin);
  };

  const fetchWalletData = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/wallet`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const contentType = response.headers.get("content-type");
      const isJson = contentType && contentType.includes("application/json");

      if (!response.ok) {
        const errorData = isJson
          ? await response.json()
          : await response.text();
        const message = isJson
          ? errorData.message || "Failed to fetch wallet data"
          : `Error ${response.status}: ${response.statusText}`;
        throw new Error(message);
      }

      const data = await response.json();
      setTransactions(data.transactions || []);
      setBalance(data.points || 0);
      setMiniAgentWalletBalance(data.agent_wallet_points || 0);

      const isFirstLogin = localStorage.getItem("is_first_login") === "true";
      if (isFirstLogin) {
        setShowPopup(true);
        localStorage.setItem("is_first_login", "false");
      }

      return true;
    } catch (error) {
      console.error("🚨 Wallet fetch error:", error.message);
      if (
        error.message.includes("401") ||
        error.message.includes("403") ||
        error.message.includes("500")
      ) {
        logout();
        return false;
      }
      throw error;
    }
  };

  useEffect(() => {
    const initWallet = async () => {
      try {
        console.log("🚀 Starting wallet initialization...");

        const hasOAuthToken = processOAuthToken();

        const isSessionValid = checkSession();
        if (!isSessionValid) {
          return;
        }

        const isApiOnline = await checkApiStatus();

        if (!isApiOnline) {
          logout();
          return;
        }

        const token = localStorage.getItem("auth_token");
        if (!token) {
          navigate("/sign_in");
          return;
        }

        // Check for first login
        const isFirstLogin = localStorage.getItem("is_first_login") === "true";
        console.log("📝 isFirstLogin:", isFirstLogin);

        if (isFirstLogin) {
          console.log("🎉 First login detected, showing reward popup");
          setShowPopup(true);
          localStorage.setItem("is_first_login", "false");
        } else {
          // Check if user just logged in (not a page refresh)
          const justLoggedIn =
            sessionStorage.getItem("just_logged_in") === "true";
          console.log("🔑 Just logged in flag:", justLoggedIn);

          // Check for returning user - show welcome back popup ONLY if they just logged in
          if (justLoggedIn) {
            const userData = localStorage.getItem("user");
            console.log("👤 Raw user data from localStorage:", userData);

            let user = null;
            try {
              user = userData ? JSON.parse(userData) : null;
            } catch (e) {
              console.error("❌ Error parsing user data:", e);
            }

            console.log("👤 Parsed user object:", user);

            // Show welcome back for users who just logged in
            if (user && token) {
              console.log("🔄 Returning user detected - just logged in");

              // Fix: Handle case where first_name or last_name might be undefined
              let userName = "User";
              if (user.first_name && user.last_name) {
                userName = `${user.first_name} ${user.last_name}`;
              } else if (user.full_name) {
                userName = user.full_name;
              } else if (user.name) {
                userName = user.name;
              } else if (user.email) {
                userName = user.email;
              }

              console.log("👋 Setting username to:", userName);
              setUsername(userName);

              // Check if user is advertising agent
              const referralResponse = await fetch(
                `${API_URL}/api/customer/referral/info`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              if (referralResponse.ok) {
                const referralData = await referralResponse.json();

                if (referralData.is_advertising_agent) {
                  // If advertising agent, redirect to Refer Customer page
                  console.log(
                    "🎯 User is advertising agent, redirecting to Refer Customer page"
                  );
                  setShowReturnPopup(false); // Don't show popup in wallet

                  // DO NOT remove the flags here - keep them for ReferCustomer
                  // sessionStorage.removeItem("just_logged_in"); // REMOVE THIS LINE

                  // Redirect immediately
                  navigate("/customer/refer-customer");
                  return;
                } else {
                  // If not advertising agent, show wallet welcome back
                  console.log(
                    "👤 User is not advertising agent, showing wallet welcome back"
                  );
                  setShowReturnPopup(true);

                  // Clear the flags here since we're showing popup in wallet
                  sessionStorage.removeItem("just_logged_in");
                  localStorage.removeItem("just_logged_in_timestamp");
                }
              } else {
                // If can't check agent status, show wallet welcome back
                setShowReturnPopup(true);
              }

              // Clear the flag so it doesn't show again on refresh
              sessionStorage.removeItem("just_logged_in");
            }
          } else {
            console.log("🔄 Page reload or refresh, not showing welcome back");
          }
        }

        await fetchWalletData(token);
        await checkMiniAgentStatus();
      } catch (error) {
        console.error("🚨 Wallet initialization error:", error);
      } finally {
        setLoading(false);
      }
    };

    initWallet();

    const cleanupActivityListeners = setupActivityListeners();

    const sessionCheckInterval = setInterval(() => {
      checkSession();
    }, 10000);

    const countdownInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          checkSession();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      cleanupActivityListeners();
      clearInterval(sessionCheckInterval);
      clearInterval(countdownInterval);
    };
  }, [navigate, location]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  // Show API checking/loading UI
  if (apiStatus === false) {
    return (
      <div className="wallet-loading">
        <LoginHeader />
        <div className="wallet-container" style={{ maxWidth: "500px" }}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">Service Unavailable</h2>
                <p>Please try again later.</p>
                <button
                  onClick={() => navigate("/sign_in")}
                  className="active-button"
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Show loading UI while fetching initial wallet data
  if (loading || apiStatus === null) {
    return (
      <div className="wallet-loading">
        <LoginHeader />
        <div className="wallet-container loading-margin" style={{minHeight:"80vh", justifyContent:"center", alignItems:"center", display:"flex", marginTop:"60px"}}>
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text" style={{border:"0"}}>
                <h2 className="highlight">TopCoin Wallet</h2>
                <p className="balance-label">Available Balance</p>
                <h1 className="balance-value">Loading...</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-5" style={{ backgroundColor: "#001964" }}>
      {showPopup && <RewardPopup onClose={() => setShowPopup(false)} />}

      {/* Welcome Back Popup */}
      {showReturnPopup && (
        <div
          className="modal-overlay"
          style={{
            zIndex: 9999,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="success-modal-box"
            style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "30px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              position: "relative",
              margin: "20px",
            }}
          >
            <button
              className="close-modal-btn"
              onClick={() => {
                console.log("❌ Closing welcome back popup");
                setShowReturnPopup(false);
              }}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "transparent")
              }
            >
              &times;
            </button>

            <h3
              style={{
                marginBottom: "20px",
                color: "#001964",
                fontSize: "22px",
                fontWeight: "600",
              }}
            >
              Welcome Back {username}!
            </h3>

            <div
              style={{
                fontSize: "60px",
                marginBottom: "15px",
                color: "#001964",
              }}
            >
              <img
                src={Profile}
                alt="Profile Icon"
                style={{ width: "60px", height: "60px" }}
              />
            </div>

            <p
              style={{
                marginBottom: "25px",
                color: "#666",
                fontSize: "16px",
              }}
            >
              {/* We're glad to see you again! */}
            </p>

            <button
              className="ok-btn"
              onClick={() => {
                console.log("✅ Welcome back popup confirmed");
                setShowReturnPopup(false);
              }}
              style={{
                backgroundColor: "#001964",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "12px 40px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s",
                width: "100%",
                maxWidth: "200px",
                marginTop: "15px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0000A0";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#001964";
                e.target.style.transform = "scale(1)";
              }}
            >
              Ok
            </button>
          </div>
        </div>
      )}

      <LoginHeader />

      <div className="wallet-container">
        {/* MINI AGENT WALLET - Show when application is accepted */}
        {step === "accepted" && (
          <div className="mini-agent-wallet">
            <div className="wallet-card success-card">
              <h2 className="highlight-mini-wallet">
                TCUK Mini Advertising Agent Wallet
              </h2>
              <img
                className="wallet-icon1"
                src={tcminiwallet}
                alt="wallet icon"
              />
              <p className="balance-label-mini-wallet">Available Balance</p>
              <h1 className="balance-value-mini-wallet">
                {Math.round(miniAgentWalletBalance ?? 0)} TopCoin
              </h1>
              <div className="mb-8 pt-1 text-center">
                <button
                  onClick={handleMiniTransactionNavigation}
                  style={{
                    color: "#0000A0",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Transaction History &gt;&gt;
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MAIN WALLET CONTENT */}
        <div className="wallet-content">
          <div className="wallet-left">
            <div className="wallet-left-text">
              <h2 className="highlight">TopCoin Wallet</h2>
              <img
                className="wallet-icon1"
                src={tcunitswallet}
                alt="wallet icon"
              />
              <p className="balance-label">Available Balance</p>
              <h1 className="balance-value">
                {balance} TopCoin (£{(balance * 0.005).toFixed(2)})
              </h1>
              <div className="mb-8 pt-1 sm:pt-4 text-center">
                <button
                  onClick={handleTransactionNavigation}
                  style={{
                    color: "#0000A0",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Transaction History &gt;&gt;
                </button>
              </div>
            </div>
          </div>

          <div className="wallet-left wallet-left1">
            <div className="wallet-left-text wallet-left-text1">
              <h2 className="highlight">TopCoin Cash Wallet</h2>
              <img
                className="wallet-icon1"
                src={tccashwallet}
                alt="wallet icon"
              />
              <h2 className="highlight cash-wallet1">N/A</h2>
            </div>
          </div>
        </div>

        <div className="additional-info">
          <p>
            An additional awarded £100 in cash bonus will be released once you
            reach a total of 22,000 TopCoin.
          </p>
        </div>

        {/* MINI AGENT SECTION - Hide when application is accepted */}
        {step !== "accepted" && (
          <div className="mini-agent">
            {step === "idle" && (
              <>
                <h2 className="highlight-request">
                  Become TCUK Mini Advertising Agent (mAdvertising Agent)
                </h2>
                <p
                  style={{
                    textAlign: "start",
                    color: "#999999",
                    padding: "0px 0px 0px 190px",
                  }}
                >
                  <b>
                    <MdOutlineDone style={{ color: "#000" }} />
                  </b>{" "}
                  Become an Agent to start earn more Topcoin
                </p>
                {/* <p
                  style={{
                    textAlign: "start",
                    color: "#999999",
                    padding: "0px 0px 0px 190px",
                  }}
                >
                  <b>
                    <MdOutlineDone style={{ color: "#000" }} />
                  </b>{" "}
                  Invite more friends to earn Topcoin from their purchase
                </p> */}
                <button
                  onClick={handleRequest}
                  style={{
                    color: "#0000A0",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Request &gt;&gt;
                </button>
              </>
            )}

            {step === "progress" && (
              <>
                <h2 className="highlight-request">
                  Become TCUK Mini Advertising Agent (mAdvertising Agent)
                </h2>
                <p
                  style={{
                    textAlign: "start",
                    color: "#999999",
                    padding: "0px 0px 0px 190px",
                  }}
                >
                  <b>
                    <MdOutlineDone style={{ color: "#000" }} />
                  </b>{" "}
                  Application Under Review
                </p>
                <p
                  style={{
                    textAlign: "start",
                    color: "#999999",
                    padding: "0px 0px 0px 190px",
                  }}
                >
                  <b>
                    <MdOutlineDone style={{ color: "#000" }} />
                  </b>{" "}
                  We will notify you once approved
                </p>
                <button
                  disabled
                  style={{
                    color: "#44475C",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "not-allowed",
                    fontSize: "inherit",
                  }}
                >
                  Request in progress.....
                </button>
              </>
            )}

            {step === "rejected" && (
              <>
                <h2 className="highlight-request" style={{ color: "#dc3545" }}>
                  Application Status: Rejected
                </h2>
                <p
                  style={{
                    textAlign: "center",
                    color: "#666",
                    padding: "10px 0",
                  }}
                >
                  Your mini agent application has been rejected. Please contact
                  support for more information.
                </p>
                <button
                  onClick={() => setStep("idle")}
                  style={{
                    color: "#0000A0",
                    fontWeight: "500",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "inherit",
                  }}
                >
                  Try Again &gt;&gt;
                </button>
              </>
            )}
          </div>
        )}

        {/* MINI AGENT FORM MODAL */}
        {showFormModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowFormModal(false)}
          >
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal-btn"
                onClick={() => setShowFormModal(false)}
              >
                &times;
              </button>
              <MiniAgentForm
                onSubmit={handleMiniAgentSubmit}
                onClose={() => setShowFormModal(false)}
              />
            </div>
          </div>
        )}

        {/* SUCCESS MODAL */}
        {showSuccessModal && (
          <div className="modal-overlay">
            <div className="success-modal-box">
              <h3>
                Thank you for your interest in becoming a TCUK Mini Advertising
                Agent.
              </h3>
              <img className="success-mail" src={success} alt="success icon" />
              <p>We will contact you soon.</p>
              <button className="ok-btn" onClick={handleSuccessModalClose}>
                OK
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Wallet;
